import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: 'app-new-performance-node-summary',
  templateUrl: './new-performance-node-summary.component.html',
  styleUrls: ['./new-performance-node-summary.component.less'],
})
export class NewPerformanceNodeSummaryComponent implements OnInit {
  @Input() perResults: any;
  requestFromNewPerfDetails = true;
  newLoadTestCase:any;
  ngOnInit(): void {
  }
  

  secondsToDhms(seconds) {
    seconds = parseInt(seconds, 10);
    var days = Math.floor(seconds / (3600*24));
    seconds  -= days*3600*24;
    var hrs   = Math.floor(seconds / 3600);
    seconds  -= hrs*3600;
    var mnts = Math.floor(seconds / 60);
    seconds  -= mnts*60;
    var dDisplay = days > 0 ? days + (days == 1 ? "D  " : "D  ") : "";
    var hDisplay = hrs > 0 ? (hrs < 10 ? "0" : "") + hrs : "00";
    var mDisplay = mnts > 0 ? (mnts < 10 ? ":0" : ":") + mnts : ":00";
    var sDisplay = seconds > 0 ? (seconds < 10 ? ":0" : ":") + seconds : ":00";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }

}
